module.exports = __webpack_public_path__ + "img/pattern-grid.1426e3f4.svg";